import React from 'react';
import { Modal } from 'react-bootstrap';

const ImageviewModal = ({ 
  show, 
  onHide, 
  fileUrl, 
  fileType = "image", // "image" or "pdf"
  altText = "Preview",
  fileName = "File"
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size={fileType === "pdf" ? "xl" : "lg"}
      style={{
        backdropFilter: "blur(10px)",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
      }}
    >
      <Modal.Body className="p-0 position-relative">
        {/* Close Button - Fixed Position Top Right */}
        <i
          className="bi bi-x"
          onClick={onHide}
          style={{
            position: "fixed",
            top: "10px",
            right: "10px",
            color: "white",
            fontSize: "54px",
            zIndex: 1050,
            cursor: "pointer",
            textShadow: "2px 2px 4px rgba(0,0,0,0.5)", // Better visibility
          }}
        ></i>

        {/* Content Based on File Type */}
        {fileType === "image" ? (
          /* Image Display */
          <img
            src={fileUrl}
            alt={altText}
            style={{ 
              width: "100%", 
              height: "auto", 
              borderRadius: "8px",
              maxHeight: "90vh",
              objectFit: "contain",
              display: "block"
            }}
          />
        ) : fileType === "pdf" ? (
          /* PDF Display */
          <div style={{ height: "80vh", width: "100%" }}>
            <iframe 
              src={fileUrl} 
              style={{ 
                width: "100%", 
                height: "100%", 
                border: "none",
                borderRadius: "8px"
              }}
              title={`PDF Preview - ${fileName}`}
            />
          </div>
        ) : (
          /* Fallback for other file types */
          <div style={{
            padding: "40px",
            textAlign: "center",
            color: "white",
            background: "rgba(0,0,0,0.8)",
            borderRadius: "8px"
          }}>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>
              📄
            </div>
            <h4 style={{ color: "white", marginBottom: "16px" }}>
              {fileName}
            </h4>
            <p style={{ color: "#ccc", marginBottom: "20px" }}>
              This file type cannot be previewed in the browser.
            </p>
            <button
              onClick={() => window.open(fileUrl, '_blank')}
              style={{
                padding: "12px 24px",
                background: "#1A73E8",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "16px"
              }}
            >
              Open in New Tab
            </button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ImageviewModal;
